<template>
  <v-app>
    <v-main>
      <transition name="page" mode="out-in">
        <router-view :key="$route.path" />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* Soft fade between pages (skipped for people who prefer less motion). */
.page-enter-active, .page-leave-active { transition: opacity 0.28s ease, transform 0.28s ease; }
.page-enter { opacity: 0; transform: translateY(10px); }
.page-leave-to { opacity: 0; }
@media (prefers-reduced-motion: reduce) {
  .page-enter-active, .page-leave-active { transition: none; }
}
html { scroll-behavior: smooth; }
@media (prefers-reduced-motion: reduce) { html { scroll-behavior: auto; } }
</style>
